import { render } from "./ShareRoute.vue?vue&type=template&id=391649d6"
import script from "./ShareRoute.vue?vue&type=script&lang=ts"
export * from "./ShareRoute.vue?vue&type=script&lang=ts"
script.render = render

export default script